import { useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import {  useCall, useEthers } from '@usedapp/core';
import { buyTruthAddresses, endpoints } from '../shared/config'
import { Strings } from './Strings';
import {ConnectButton}  from './ConnectButton';
import {LoadingStack}  from './elements/LoadingStack';
import ClaimConfirmation  from './ClaimConfirmation';
import { JsonRpcProvider } from '@ethersproject/providers'
import BuyTruthABI from '@buytruth/contracts/artifacts/contracts/BuyTruth.sol/BuyTruth.json';
import { Contract, utils } from 'ethers';
import { darkTheme, Theme, SwapWidget } from '@uniswap/widgets'

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import PieChartIcon from '@mui/icons-material/PieChart';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GradeIcon from '@mui/icons-material/Grade';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import PercentIcon from '@mui/icons-material/Percent';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const fetch = require('node-fetch');
const listStyle={ width: '100%', boxShadow: '0px 40px 120px 0px rgba(0, 0, 0, 0.5)', bgcolor: '#0c0c13', marginLeft: '0 !important', color: '#91919f !important', borderRadius: '24px'};
const avatarStyle={bgcolor: '#1b1b2a'};
const secondaryStyle={ sx: {color: '#fff', fontWeight: 'bold', fontSize: '1.6rem'} };
const infoStyle={marginBottom: '-5px', paddingTop: '4px'};

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} sx={{cursor:'default'}}/>
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 360,
    lineHeight: '20px'
  },
});

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#9c27b0',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#9a9a9a',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

interface TokenInfo {
  usdPrice: number;
  nativePrice: number;
}



interface ChainProps {
  account: string;
  chainId: number;
  tokenInfo: TokenInfo;
  pricesInUsd: boolean;
  readOnlyMode: boolean;
}

var pricesInterval: any;
export const Summary = () => {

  var { account, chainId } = useEthers();
  
  var { readOnlyAccount } = useParams();
  
  const [readOnlyMode, setReadOnlyMode] = useState(!account && readOnlyAccount ? true : false);
  const [tokenInfo, setTokenInfo] = useState({usdPrice: 0, nativePrice: 0});
  const [pricesInUsd, setPricesInUsd] = useState(false);
  
  if(readOnlyMode){
    account = readOnlyAccount;
  }

  const getPrices = () => {
    fetch(endpoints.api + '/tokenInfo').then(async (response: any) => {
      const json = await response.json();

      var newTokenInfo = {
        usdPrice: parseFloat(json.priceUsd),
        nativePrice: parseFloat(json.priceNative)
      };

      if(tokenInfo.usdPrice !== newTokenInfo.usdPrice){
        setTokenInfo(newTokenInfo);
      }
    });
  }
  getPrices();

  if(pricesInterval){
    clearInterval(pricesInterval)
  }
  pricesInterval = setInterval(getPrices, 12100);

  const usdPriceSwitchHandler = (event: any) => {
    setPricesInUsd(event.target.checked);
  }


  
  return (
    <>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 3, sm: 4, md: 5 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid item xs={4} sx={{zIndex:2}}>
          { account && chainId ?
            <>
              <h3 style={{marginTop:'50px', marginBottom:'20px',  textTransform: 'none'}}>Balances&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<FormControlLabel control={<IOSSwitch sx={{ m: 1 }}  onChange={ usdPriceSwitchHandler } />} label="USD Values" /></h3>
              
              <AccountSummary account={account} chainId={chainId} tokenInfo={tokenInfo} pricesInUsd={pricesInUsd} readOnlyMode={readOnlyMode}/>
            </>
          : <></> }
        </Grid>
        <Grid item xs={4} sx={{zIndex:2}}>
          
          { account && chainId ?
            <>
              <h3 style={{marginTop:'50px', marginBottom:'20px', textTransform: 'none'}}>Rewards</h3>
              <RewardsSummary account={account} chainId={chainId} tokenInfo={tokenInfo} pricesInUsd={pricesInUsd} readOnlyMode={readOnlyMode}/>
            </>
          : <>
              <ConnectButton setReadOnlyMode={setReadOnlyMode}/>
              <h3 style={{marginTop:'20px', fontSize: '40px', textAlign: 'center'}}>Please connect your wallet</h3>
              { chainId ? <h6 style={{marginTop:'20px', fontSize: '14px', textAlign: 'center'}}>TRUTH Contract Address: <a style={{textDecoration: "underline", color: "#fff"}} target="_blank" rel="noreferrer" href={"https://etherscan.io/token/" + buyTruthAddresses[chainId] }>{buyTruthAddresses[chainId]}</a></h6> : <></> }
              <LoadingStack/>
              <ReadOnlyAddress onChange={setReadOnlyMode}/>
            </> }
        </Grid>
        <Grid item xs={4} sx={{zIndex:2}}>
          { account && chainId && !readOnlyMode ? 
            <>
              <h3 style={{marginTop:'50px', marginBottom:'20px', textTransform: 'none'}}>Trade</h3> 
              <TradeWidget account={account} chainId={chainId} tokenInfo={tokenInfo} pricesInUsd={pricesInUsd} readOnlyMode={readOnlyMode}/>
            </>
          : <></> }
          { account && chainId && readOnlyMode ? 
            <>
              <h3 style={{marginTop:'50px', marginBottom:'20px', textTransform: 'none'}}>Trade</h3> 
              <p>Connect your wallet to trade</p>
              <ConnectButton setReadOnlyMode={setReadOnlyMode}/>
            </>
          : <></> }
        </Grid>
        <Grid item xs={12} sx={{zIndex:2}}>
          { account && chainId ?
            <div style={{marginTop: '30px', height: '900px', position: 'relative', width:'100%'}} id="dexscreener-embed"><iframe title='dexscreener' style={{height: '900px'}} src={"https://dexscreener.com/ethereum/" + buyTruthAddresses[chainId] + "?embed=1&theme=dark"}></iframe></div>
          : <></> }
        </Grid>
      </Grid>
      
    </>
  );
};



export const ReadOnlyAddress = ({onChange}: any) => {

  const validate = (address: any) => {
    if(address.length === 42 && address.startsWith("0x")){
      var dappPrefix = window.location.href.includes("dapp") ? "/dapp" : "";
      window.location.href = dappPrefix + '/#/readonly/' + address;
      onChange(true);
    }
  }

  return (
    <>
        <h5 style={{marginTop:'20px', marginBottom:'20px',textAlign: 'center'}}>For read-only view, enter an address below</h5>
        <form className="first__form form">
            <div className="form__row">
              <div className="form__input">
                <label>
                  <input style={{color: '#fff'}} type="text" className="item_field" placeholder="Address for read-only experience" onChange={(e) => { validate(e.target.value) }}/>
                </label>
              </div>
            </div>
        </form>
    </>
  );
};



const AccountSummary = ({ account, chainId, tokenInfo, pricesInUsd, readOnlyMode }: ChainProps) => {

    const navigate = useNavigate();
    const btContract = chainId && new Contract(buyTruthAddresses[chainId], BuyTruthABI.abi);
  
    const formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });
    const usdFormatter = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" });

  
    const availableBalanceResponse = useCall(account && btContract && {
      contract: btContract,
      method: 'balanceOf',
      args: [account],
    });
    const availableBalance = availableBalanceResponse ?
      availableBalanceResponse.error ? 
        Strings.errorFetching : 
          tokenInfo && pricesInUsd ? usdFormatter.format(tokenInfo.usdPrice * parseFloat(utils.formatEther(availableBalanceResponse.value[0]))) : formatter.format(parseFloat(utils.formatEther(availableBalanceResponse.value[0]))) : 
            Strings.loading


    const totalBalanceResponse = useCall(account && btContract && {
      contract: btContract,
      method: 'balanceTotalOf',
      args: [account],
    });
    const totalBalance = totalBalanceResponse ? 
      totalBalanceResponse.error ? 
        Strings.errorFetching : 
          tokenInfo && pricesInUsd ? usdFormatter.format(tokenInfo.usdPrice * parseFloat(utils.formatEther(totalBalanceResponse.value[0]))) : formatter.format(parseFloat(utils.formatEther(totalBalanceResponse.value[0]))) : 
            Strings.loading


    const penaltyPercentResponse = useCall(account && btContract && {
      contract: btContract,
      method: 'calculatePenaltyPercentWithMultiplier',
      args: [account],
    });
    const penaltyPercent = penaltyPercentResponse ?
      penaltyPercentResponse.error ? 
        Strings.errorFetching : 
          (parseInt(penaltyPercentResponse.value[0].toString()) / 100).toFixed(2) + "%" : 
          Strings.loading;
    

    const daysHeldResponse = useCall(account && btContract && {
      contract: btContract,
      method: 'numDaysHeld',
      args: [account],
    });
    const daysHeld = daysHeldResponse ?
      daysHeldResponse.error ? 
      Strings.errorFetching : 
        daysHeldResponse.value[0] > BigInt(99999) ? 'Not Tracked' : daysHeldResponse.value[0].toString() : 
        Strings.loading;


    const totalBurnedResponse = useCall(account && btContract && {
      contract: btContract,
      method: 'totalBurned',
      args: [],
    });
    const totalBurned = totalBurnedResponse ?
      totalBurnedResponse.error ? 
      Strings.errorFetching : 
        tokenInfo && pricesInUsd ? usdFormatter.format(tokenInfo.usdPrice * parseFloat(utils.formatEther(totalBurnedResponse.value[0]))) : formatter.format(parseFloat(utils.formatEther(totalBurnedResponse.value[0]))) : 
        Strings.loading;

    const charityWalletResponse = useCall(account && btContract && {
      contract: btContract,
      method: 'balanceTotalOf',
      args: ["0xCA2Bfb05E7fa10946EA4344031344E128d018cCf"],
    });
    const charityBalance = charityWalletResponse ? 
    charityWalletResponse.error ? 
        Strings.errorFetching : 
          tokenInfo && pricesInUsd ? usdFormatter.format(tokenInfo.usdPrice * parseFloat(utils.formatEther(charityWalletResponse.value[0]))) : formatter.format(parseFloat(utils.formatEther(charityWalletResponse.value[0]))) : 
            Strings.loading
    
    return (
      <>
        <List sx={listStyle}>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <AccountBalanceWalletIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.availableBalanceTooltip}>
                  <Box>{Strings.availableBalance} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={availableBalance} 
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <AccountBalanceIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.totalBalanceTooltip}>
                  <Box>{Strings.totalBalance} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={totalBalance}
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <HourglassEmptyIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.daysHeldTooltip}>
                  <Box>{Strings.daysHeld} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={daysHeld} 
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <FmdBadIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.penaltyPercentTooltip}>
                  <Box>{Strings.penaltyPercent} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={penaltyPercent} 
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <WhatshotIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.totalBurnedTooltip}>
                  <Box>{Strings.totalBurned} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={totalBurned} 
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <VolunteerActivismIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.charityBalanceTooltip}>
                  <Box>{Strings.charityBalance} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={charityBalance} 
            />
            <Button className={'beautiful'} sx={{boxShadow:'none !important', padding: '3px 3px', height: '50px !important'}} onClick={()=>{ navigate("/charity") }}>Charities</Button>




          </ListItem>
        </List>
      </>
    );

};


const RewardsSummary = ({ account, chainId, tokenInfo, pricesInUsd, readOnlyMode}: ChainProps) => {

  const [claimConfirmationOpen, setClaimConfirmationOpen] = useState(false);

  const btContract = chainId && new Contract(buyTruthAddresses[chainId], BuyTruthABI.abi);

  const formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });
  const usdFormatter = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" });
 

  const availableRewardsResponse = useCall(account && btContract && {
    contract: btContract,
    method: 'availableRewards',
    args: [account],
  });
  const availableRewards = availableRewardsResponse ? 
    availableRewardsResponse.error ? 
    Strings.errorFetching : 
      tokenInfo && pricesInUsd ? usdFormatter.format(tokenInfo.usdPrice * parseFloat(utils.formatEther(availableRewardsResponse.value[0]))) : formatter.format(parseFloat(utils.formatEther(availableRewardsResponse.value[0]))) : 
        Strings.loading

  const tokenHoldingsEligibleForRewardsResponse = useCall(account && btContract && {
    contract: btContract,
    method: 'balanceEligibleForRewards',
    args: [account],
  });
  const tokenHoldingsEligibleForRewards = tokenHoldingsEligibleForRewardsResponse ? 
    tokenHoldingsEligibleForRewardsResponse.error ? 
    Strings.errorFetching : 
      tokenInfo && pricesInUsd ? usdFormatter.format(tokenInfo.usdPrice * parseFloat(utils.formatEther(tokenHoldingsEligibleForRewardsResponse.value[0]))) : formatter.format(parseFloat(utils.formatEther(tokenHoldingsEligibleForRewardsResponse.value[0]))) : 
        Strings.loading

  const tokenSupplyEligibleForRewardsResponse = useCall(btContract && {
    contract: btContract,
    method: 'supplyEligibleForRewards',
    args: [],
  });
  const tokenSupplyEligibleForRewards = tokenSupplyEligibleForRewardsResponse ? 
    tokenSupplyEligibleForRewardsResponse.error ? 
    Strings.errorFetching : 
      tokenInfo && pricesInUsd ? usdFormatter.format(tokenInfo.usdPrice * parseFloat(utils.formatEther(tokenSupplyEligibleForRewardsResponse.value[0]))) : formatter.format(parseFloat(utils.formatEther(tokenSupplyEligibleForRewardsResponse.value[0]))) : 
        Strings.loading

  const ownershipOfEligibleSupply = tokenHoldingsEligibleForRewardsResponse && tokenSupplyEligibleForRewardsResponse ? 
    tokenHoldingsEligibleForRewardsResponse.error || tokenSupplyEligibleForRewardsResponse.error ?
    Strings.errorFetching : 
      ((parseFloat(utils.formatEther(tokenHoldingsEligibleForRewardsResponse.value[0])) / parseFloat(utils.formatEther(tokenSupplyEligibleForRewardsResponse.value[0]))) * 100).toFixed(2) + "%" : 
        Strings.loading;
  
  const rewardsPoolAccruedResponse = useCall(account && btContract && {
    contract: btContract,
    method: 'rewardsPoolBalance',
    args: [],
  });
  const rewardsPoolAccrued = rewardsPoolAccruedResponse ? 
    rewardsPoolAccruedResponse.error ? 
    Strings.errorFetching : 
      tokenInfo && pricesInUsd ? usdFormatter.format(tokenInfo.usdPrice * parseFloat(utils.formatEther(rewardsPoolAccruedResponse.value[0]))) : formatter.format(parseFloat(utils.formatEther(rewardsPoolAccruedResponse.value[0]))) : 
        Strings.loading


    return (
      <>
        <List sx={listStyle}>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <EmojiEventsIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.claimableRewardsTooltip}>
                  <Box>{Strings.claimableRewards} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={availableRewards} />
              { !readOnlyMode && availableRewards !== '0' && availableRewards !== Strings.errorFetching && availableRewards !== Strings.loading ? 
                <>
                  <Button className={'beautiful'} sx={{boxShadow:'none !important', padding: '3px 3px', height: '50px !important'}} onClick={() => { setClaimConfirmationOpen(true); }}>Claim</Button>
                </> 
              : <></>}
              <ClaimConfirmation chainId={chainId} open={claimConfirmationOpen} onClose={() => { setClaimConfirmationOpen(false); }}/>
            
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <DataUsageIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.holdingsEligibleForRewardsTooltip}>
                  <Box>{Strings.holdingsEligibleForRewards} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={tokenHoldingsEligibleForRewards}/>
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <PieChartIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.supplyEligibleForRewardsTooltip}>
                  <Box>{Strings.supplyEligibleForRewards} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              } 
              secondaryTypographyProps={secondaryStyle} 
              secondary={tokenSupplyEligibleForRewards} 
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <PercentIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.ownershipOfEligibleSupplyTooltip}>
                  <Box>{Strings.ownershipOfEligibleSupply} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              }
              secondaryTypographyProps={secondaryStyle} 
              secondary={ownershipOfEligibleSupply === "NaN%" ? "0%": ownershipOfEligibleSupply}/>
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={avatarStyle}>
                <GradeIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText 
              primary={
                <CustomWidthTooltip title={Strings.rewardsPoolTooltip}>
                  <Box>{Strings.rewardsPool} <InfoIcon sx={infoStyle}/></Box>
                </CustomWidthTooltip>
              } 
              secondaryTypographyProps={secondaryStyle} 
              secondary={rewardsPoolAccrued} 
            />
          </ListItem>
        </List>
      </>
    );

};

declare const window: any

const TradeWidget = ({ account, chainId }: ChainProps) => {
  
  const { library } = useEthers();
  
  const addTokenToMetamask = async (txHash: string, data: any) => {

    if(data?.info?.trade?.swaps?.[0]?.outputAmount?.currency?.symbol === 'TRUTH' && window.ethereum){
      const params = chainId && {
        type: 'ERC20',
        options: {
          address: buyTruthAddresses[chainId],
          symbol: 'TRUTH',
          decimals: 18
        },
      };
    
      window.ethereum.request({ method: 'wallet_watchAsset', params })
          .catch((error: Error) => console.log(error))
    }
  }

  const myDarkTheme: Theme = {
    ...darkTheme, 
    accent: '#7f42f7',
    primary: '#FFF',
    secondary: '#91919f',
    module: 'rgba(255, 255, 255, 0.02)',
    interactive: 'rgba(255, 255, 255, 0.1)',
    container: '#0c0c13',
    outline: '#0c0c13',
    networkDefaultShadow: 'rgba(0, 0, 0, 0.1)',
    fontFamily: "Roboto",
    borderRadius: {
      large: 1,
      medium: 1,
      small: 1,
      xsmall: 1
    }
  }

  const MY_TOKEN_LIST = chainId ? [
    {
      "name": "BuyTruth",
      "address": buyTruthAddresses[chainId],
      "symbol": "TRUTH",
      "decimals": 18,
      "chainId": chainId,
      "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x0000000000085d4780B73119b644AE5ecd22b376/logo.png"
    },
    
    {
      "name": "USD Coin",
      "address": "0x07865c6E87B9F70255377e024ace6630C1Eaa37F",
      "symbol": "USDC",
      "decimals": 6,
      "chainId": 5,
      "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
    },
    {
      "name": "USD Coin",
      "address": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      "symbol": "USDC",
      "decimals": 6,
      "chainId": 1,
      "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
    },
    {
      "name": "Tether USD",
      "address": "0x509Ee0d083DdF8AC028f2a56731412edD63223B9",
      "symbol": "USDT",
      "decimals": 6,
      "chainId": 5,
      "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
    },
    {
      "name": "Tether USD",
      "address": "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      "symbol": "USDT",
      "decimals": 6,
      "chainId": 1,
      "logoURI": "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
    }
  ] : [];

  var jsonRpcMap : any = {};
  jsonRpcMap[endpoints.chainId] = endpoints.rpcUrl;

    return (
      <>
        {
            account && chainId && chainId !== 31337 && library ? 
              <div className="Uniswap">
                <SwapWidget
                  provider={library as JsonRpcProvider}
                  jsonRpcUrlMap={jsonRpcMap}
                  hideConnectionUI={true}
                  theme={myDarkTheme}
                  tokenList={MY_TOKEN_LIST}
                  defaultInputTokenAddress='NATIVE'
                  defaultInputAmount={0.04}
                  defaultOutputTokenAddress={buyTruthAddresses[chainId]}
                  permit2={true}
                  onTxSuccess={addTokenToMetamask}
                  brandedFooter={false}
                  width='100%'
                />
                <div style={{textAlign: 'center', marginTop:'5px', fontWeight: 'bold'}}><a style={{color: '#fc9fff', textShadow: '0px 0px 5px #000'}} target="_blank" rel="noreferrer" href={'https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=' + buyTruthAddresses[chainId]}>Having trouble? Try swapping on Uniswap...</a></div>
              </div>
              :
              <>
                <h4 style={{marginTop:'50px'}}>Uniswap not available on this network</h4>
                <LoadingStack/>
              </> 
        }
      </>
    );

};

